<template lang="pug">
.container-upload(id="FileUpload-container")
  el-upload(
    ref='upload',
    :action='uploadUrl',
    :auto-upload="false",
    multiple,
    :data='data',
    :with-credentials='true',
    :show-file-list='true',
    :on-success='finishFileUpload',
    :on-change='updateFileList',
    :on-remove='updateFileList',
    :on-error='updateErroredFileList',
    :http-request='httpRequest',
    :accept='acceptedExtensions')
      el-button.float-right(id="FileUpload-uploadButton" v-if="showFileList && !uploadInProgress && !someMessagesExist()", style='margin-left: 10px;', size='mini', type='primary', @click='submitUpload')
        font-awesome-icon(icon="upload")
        span &nbsp;&nbsp;  {{$t('upload')}}
      el-button.float-right(id="FileUpload-cancelButton" v-if="showFileList && !uploadInProgress", style='margin-left: 10px;', size='mini', type='primary', @click='clearFiles')
        font-awesome-icon(:icon="someMessagesExist() ? 'check' : 'times'")
        span &nbsp;&nbsp;  {{ someMessagesExist() ? $t('ok') : $t('cancel')}}
      el-button.select-files(id="FileUpload-selectFileButton" ref='selectFiles', slot='trigger', size='mini', type='primary')
        font-awesome-icon(icon="folder")
        span &nbsp;&nbsp;  {{$t('select file(s) to upload')}}
      el-checkbox.convert-checkbox(id="FileUpload-convertToMP4Checkbox" v-if="someFilesAreMP4", v-model="convert") {{ $t('Convert mp4 anyway?') }}
  br
  .files-container(v-if="erroredFiles.length > 0")
    .file-row
      p.warning {{ $t('Some errors occured during upload') }}
      el-button.float-right(id="FileUpload-errorClearButton" style='margin-left: 10px;', size='mini', type='primary', @click='erroredFiles = [], files = [], uploadInProgress = false')
        font-awesome-icon(icon="times")
        span &nbsp;&nbsp;  {{$t('clear')}}
    .file-row(v-for='file of erroredFiles' :key='file.name' :id="'FileUpload-errorFileRow' + file.id")
      .percentage
        el-progress(:percentage='parseInt(file.file.percentage)')
      .name {{ file.file.name }}
      .size {{ humanFileSize(file.file.size) }}
      .status.warning {{ file.error.status }}
  .files-container(v-if="files.length > 0")
    p.warning(v-if='someFilesAreTooBig') {{ $t(`Some files exceed max upload size of ${humanFileSize(maxUploadSizeB)}`) }}
    .file-row(v-for='file of files' :key='file.name' :id="'FileUpload-fileRow' + file.id")
      .percentage
        el-progress(:percentage='parseInt(file.percentage)')
      .name {{ file.name }}
      .size(:class="{ 'warning': file.size > maxUploadSizeB }") {{ humanFileSize(file.size) }}
      .status {{ $t(digestStatus(file)) }}
        .gotofolder(
          v-if='file.response && file.response.message === "FILE_EXISTS"',
          type="text",
          size="mini",
          @click="gotoFolderWithFile(file.response.data.originalFileSHA256)"
        )
          font-awesome-icon(icon="folder-open")
      .delete
        .deleteButton(
          v-if='file.percentage < 1',
          type="text",
          size="mini",
          @click="removeFile(file)",
          :title="$t('remove from upload')",
          :id="'FileUpload-removeFile' + file.id"
        )
          font-awesome-icon(icon="times")
</template>

<script>
import Vue from 'vue'
import PromiseQueue from 'promise-queue'
import ajax from 'element-ui/packages/upload/src/ajax'
import testUtils from './../Common/textUtils.mixin'

const queue = new PromiseQueue(5, Infinity)

export default {
  mixins: [testUtils],
  props: ['side', 'folder'],
  created () {
  },
  data () {
    return {
      errors: { },
      data: {
        convert: true,
        MediumId: undefined,
        _csrf: undefined
      },
      uploadInProgress: false,
      fileListLength: 0,
      files: [],
      convert: true,
      mediumPathInLibrary: undefined,
      type: null,
      erroredFiles: []
    }
  },
  methods: {
    removeFile (file) {
      this.files = this.files.filter(f => f.uid !== file.uid)
      this.$refs.upload.uploadFiles = this.$refs.upload.uploadFiles.filter(f => f.uid !== file.uid)
      this.updateFileList(file, this.$refs.upload.uploadFiles)
    },
    async gotoFolderWithFile (originalFileSHA256) {
      const medium = this.$store.state.Medium.media_list.find((m) => {
        if (m.File) {
          return m.File.originalsha256 === originalFileSHA256 && !m.type.startsWith('PlayList')
        }
        return false
      })
      console.log(this.$store.state.Medium.media_list)
      await this.__getMediumPathInLibrary(medium.id)
    },
    async __getMediumPathInLibrary (mediumId) {
      const mediumPathInLibrary = (await Vue.axios.post('medium/findPlaylistsAffectedFullPath', { 'Medium': mediumId })).data.occurrences
      for (let index = 0; index < mediumPathInLibrary.length; index++) {
        mediumPathInLibrary[index].fullPath = this.__makeRichPath(mediumPathInLibrary[index])
      }
      this.$emit('loadPathInLibrary', mediumPathInLibrary.find(path => path.type === 'PlayListLibraryRoot').fullPath.mediaIds)
    },
    __makeRichPath (playlistWithFullPath) {
      return {
        mediaNames: playlistWithFullPath.path.split('/'),
        mediaIds: playlistWithFullPath.pathByMediumId.split('/'),
        playlistitemsIds: playlistWithFullPath.pathByPlaylistitemid.split('/')
      }
    },
    triggerSelectFiles (type) {
      this.type = type
      this.$nextTick(() => this.$refs.selectFiles.$el.click())
    },
    digestStatus (file) {
      if (file.size > this.maxUploadSizeB) return this.$t('file too big')
      if (file.status === 'success' && file.response && file.response.message) {
        return this.$t(file.response.message)
      }
      if (parseInt(file.percentage) === 100 && file.status !== 'success') {
        return this.$t('processing')
      }
      return this.$t(file.status)
    },
    submitUpload () {
      this.uploadInProgress = true
      this.data.convert = this.convert
      this.data.MediumId = this.folder.id
      this.data._csrf = this.$store.state.User.csrfToken
      this.$refs.upload.submit()
    },
    clearFiles () {
      if (this.$refs.upload) this.$refs.upload.clearFiles()
      this.files = []
      this.$store.dispatch('File/setUploadingFiles', [])
    },
    updateFileList (file, filelist) {
      if (this.uploadInProgress) return
      this.fileListLength = filelist.length
      this.files = filelist
      this.$store.dispatch('File/setUploadingFiles', JSON.parse(JSON.stringify(this.files)))
    },
    updateErroredFileList (error, file, filelist) {
      let errorMessage = {}
      try {
        errorMessage.status = JSON.parse(error.message).message
      } catch (e) {
        errorMessage = error
      }
      this.erroredFiles.push({ error: errorMessage, file })
    },
    async finishFileUpload (file) {
      this.fileListLength--
      if (this.fileListLength === 0) {
        await this.$store.dispatch('File/getData')
        this.uploadInProgress = false
        this.$emit('uploadFinished')
        if (!this.someMessagesExist()) this.clearFiles()
      }
    },
    httpRequest (options) {
      queue.add(() => new Promise((resolve, reject) => {
        ajax({
          ...options,
          onSuccess (res) {
            resolve()
            options.onSuccess(res)
          },
          onError (res) {
            resolve()
            options.onError(res)
          }
        })
      }))
    },
    someMessagesExist () {
      const messages = this.files
        .filter(file => file.response)
        .filter(file => file.response.message)
        .map(file => file.response.message)
      return messages.length > 0
    }
  },
  computed: {
    maxUploadSizeB () {
      return this.$store.state.User.user.Networks
        .find(n => n.id === this.$store.state.User.user.lastNetworkId).maxUploadSizeB
    },
    showFileList () {
      return this.files.length > 0
    },
    someFilesAreTooBig () {
      let returnVal = false
      for (const file of this.files) {
        if (
          file.size > this.maxUploadSizeB
        ) {
          returnVal = true
          break
        }
      }
      return returnVal
    },
    someFilesAreMP4 () {
      let returnVal = false
      for (const file of this.files) {
        if (
          file.name.indexOf('.MP4') > -1 ||
          file.name.indexOf('.mp4') > -1
        ) {
          returnVal = true
          break
        }
      }
      return returnVal
    },
    acceptedExtensions () {
      if (this.type === 'UploadHTMLzip') {
        return '.zip,.ZIP'
      }
      if (this.type === 'UploadFile') {
        return '.*'
      }
      return '.jpg,.jpeg,.JPG,.JPEG,.png,.PNG,.mp3,.mp4,.MP4,.webm,.WEBM,.mpg,.MPG,.mpeg,.MPEG,.mov,.MOV,.mkv,.MKV,.m4v,.M4V,.flv,.FLV,.avi,.AVI,.svg,.SVG,.wmv,.WMV'
    },
    uploadUrl () {
      if (this.type === 'UploadHTMLzip') {
        return this.apiUrl('file/htmlZIPUpload')
      }
      if (this.type === 'UploadFile') {
        return this.apiUrl('file/uploadCustomFile')
      }
      return this.apiUrl('file/upload')
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container-upload {
  display: flex;
  flex-direction: column;
}
.files-container {
  display: flex;
  flex-direction: column;
  .file-row {
    display:flex;
    font-size: $--font-size-base;
    border-bottom: $--border-light;
    padding: 10px 0px;
    .percentage {
      width:30%;
    }
    .name {
      width: 40%;
      overflow: hidden;
    }
    .size{
      width: 15%;
    }
    .status {
      width: 15%;
      display: flex;
      .gotofolder {
        cursor: pointer;
        margin-left: 10px;
      }
    }
    .deleteButton {
      cursor: pointer;
      margin-left: 10px;
      color: $--color-text-secondary
    }
  }
}
.convert-checkbox {
  margin-left: 30px;
}
.select-files {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/File/Upload.vue